import { useCrudSelection } from '@/atoms'

export const useListType = () => {
  const [trafficProfileSelection] = useCrudSelection('trafficProfile')
  return trafficProfileSelection.length === 0 ? 'trafficProfiles' : 'trafficAreas'
}
